import { render, staticRenderFns } from "./TheHeaderAcc.vue?vue&type=template&id=c3baeb9a&scoped=true"
import script from "./TheHeaderAcc.vue?vue&type=script&lang=js"
export * from "./TheHeaderAcc.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderAcc.vue?vue&type=style&index=0&id=c3baeb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3baeb9a",
  null
  
)

export default component.exports